/**
 * 模块导入
 * @author 意毅深
 * @date 2022/01/26 09:22
 */
import sample from './sample'
export default {
  sample
}



// WEBPACK FOOTER //
// ./src/store/modules/index.js